import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { BsBookmarkHeart, BsFillBookmarkHeartFill } from "react-icons/bs";
import commonObj from '../../utils/Common';

import {
  useAuthContext,
  useCartContext,
  useProductsContext,
  useWishlistContext,
} from "../contexts";
import { getProductByIdService } from "../../api/apiServices";
import { StarRating } from "../frontComponents";
import { notify } from "../../utils/utils";
import services from '../../services/index'
import { Loader } from "../frontComponents";
import { LazyLoadImage } from 'react-lazy-load-image-component';


const ProductDetails = ({customproductId}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { productId } = useParams();
  const { token } = useAuthContext();
  //const { getProductById, allProducts } = useProductsContext();
  const { addProductToCart, disableCart } = useCartContext();
  const { addProductToWishlist, deleteProductFromWishlist, disableWish } =
    useWishlistContext();
  const [loading, setLoading] = useState(false);
  const [product, setProduct ] = useState([])
  const [mainImg, setMainImg ] = useState('')

  //const product = getProductById(productId);

  useEffect(() => {
    (async () => {
      setLoading(true);

      try {
        const response = await services.productService.getProductById( productId || customproductId )
        if(response.status===1){
          
          let url = {url:response.data?.url}
          setProduct({...response.data?.result, ...url})
          setMainImg(displayMainImage(response.data?.result?.productImage, response.data?.url))
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const addtocart = () => {
    addProductToCart(product, product?.url, product.productPrice, null) 
    setTimeout(() => {
      navigate(`/cart`);
    }, 300);
  }

  const videoExtension = (fileName)=>{
    if(fileName!='' && fileName!==null){ 
        let value = fileName.split('.').pop();
        var options =[ 'flv','gif','mov','mp4','m4v','3gp', '3g2', 'nsv', 'm4p', 'amv', 'vob', 'webm', 'vob' ];
        var data = options.includes(value);
        if(data==true){
            return true;
        }else{
            return false;
        }
    }
  }

  const displayMainImage = (name, url)=> { console.log(name,url)
    return (videoExtension(name)!==true) ?  (<LazyLoadImage key="0021" src={url+name}  effect="blur" className=" w-full object-cover max-w-md"/>)
    : (<video controls style={{minHeight:216+'px',width:'auto'}}>
    <source src={url+name} type="video/mp4"/>
    </video>)
  }

  return (
    <>
    {loading ? (
      <Loader />
    ) : (  product?.productName && 
    <div className="h-fit flex justify-center items-center pt-5 sm:pt-3 pb-2 relative"> {console.log(product)}
      <main className="grid grid-rows-1 sm:grid-cols-2 gap-2 sm:gap-6 ">
        <section className="relative d-flex flex-column items-center justify-center ">
         <div className="main_product_image overflow-hidden justify-center items-center">
          { mainImg }
         </div> 
            <div className="product_thumbnail_image flex py-4 justify-between gap-5"> {product?.productMedia?.length>0 && product.productMedia.map( (media,i) => (
              (videoExtension(media?.mediaName)!==true) ?  (<LazyLoadImage key={i} src={product?.url+media?.mediaName}  height="150" width="24%" className=" w-1/3 max-w-4xl object-cover w-[20%]" onClick={()=>setMainImg(displayMainImage(media?.mediaName, product?.url))} style={{cursor:'pointer'}}/>)
              : (<video width="24%" height="150px" onClick={()=>setMainImg(displayMainImage(media?.mediaName, product?.url))} style={{cursor:'pointer'}}>
              <source src={product?.url+media?.mediaName} type="video/mp4"/>
        </video>)
            )
          )}</div>
        </section>

        <section className="p-4 rounded-md shadow-sm bg-white/[0.7] flex flex-col gap-3 sm:gap-5 ">
          <div className="flex flex-col gap-2">
            <h1 className=" text-2xl sm:text-3xl font-bold">{product?.productName}</h1>
            <p className=" text-gray-600 text-sm sm:text-base">
              {product?.productShortDescription}
            </p>
            {/*<div className="flex items-center gap-1">
              <StarRating />

              <span className="text-xs text-gray-400">
                ({product?.rating}) Rating
              </span>
            </div>*/}
          </div>

          <div className="flex flex-col gap-2  ">
            <h2 className="  text-lg font-semibold">{commonObj.getLabel('About_Product')} </h2>
            <ul className="flex w-full flex-col">
          
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm ">{commonObj.getLabel('Sku')}: </span>
                  {product?.productSku}
                </li>
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">{commonObj.getLabel('Category')}: </span>
                  {product?.category?.categoryName}
                </li>
                {/*<li className="flex gap-5 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">Cross Price: </span>
                  {commonObj.getCurrency('mn')}{product?.productCrossPrice}
                </li>*/}
                
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">{commonObj.getLabel('From_Where')}: </span>
                  {product?.fromWhere}
                </li>
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">{commonObj.getLabel('From_When')}: </span>
                  {product?.fromWhen}
                </li>
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">{commonObj.getLabel('Production_Method')}: </span>
                  {product?.productionMethod}
                </li>
                <li className="flex gap-5 border-b py-2 my-2 border-solid border-slate-200 w-full items-center justify-between">
                  <span className="text-gray-500 text-sm">{commonObj.getLabel('Quantity_Kg')}: </span>
                  {product?.productQuantity}
                </li>
           
            </ul>
          </div>

          <div className="flex gap-5 w-full items-center justify-between">
          {commonObj.getLabel('Price')}:
            <span className="ms-1 text-xl sm:text-2xl text-amber-600">
            {commonObj.getCurrency('mn')}{product?.productPrice}
            </span>
            {/*<span className="text-sm text-gray-600 line-through">
              ₹{product?.productPrice}
            </span>*/}
          </div>
       
          <div className={`w-full   flex gap-4 items-center   flex-wrap  `}>
            <a
              className="rounded-lg xl:h-10 flex items-center text-white justify-center h-12 px-4 mx-2 text-sm text-center  transition-colors duration-200 transform  xl:h-10 bg-green-500 hover:bg-green-600 focus:outline-none cursor-pointer"
              disabled={disableCart}
              onClick={() => {
                if (!token) {
                  navigate("/login", { state: { from: location.pathname } });
                  notify("warn", commonObj.getLabel('Please_Login_to_continue'));
                } else {
                  if (!product?.inCart) {
                    //addProductToCart(product);
                    addtocart()
                  } else {
                    navigate("/cart");
                  }
                }
              }}
            >
          
              {product?.inCart ? commonObj.getLabel('Go_to_Bag') : commonObj.getLabel('Buy_Now')}
            </a>

            {/* <a
              className="rounded-lg xl:h-10 flex items-center text-white justify-center h-12 px-4 mx-2 text-sm text-center  transition-colors duration-200 transform  xl:h-10 bg-green-500 hover:bg-green-600 focus:outline-none"
              disabled={disableWish}
              onClick={() => {
                if (!token) {
                  navigate("/login", { state: { from: location.pathname } });
                  notify("warn", "Please Login to continue");
                } else {
                  if (product?.inWish) {
                    deleteProductFromWishlist(product._id);
                  } else {
                    addProductToWishlist(product);
                  }
                }
              }}
            >
               <span>Proposed Price</span>
            </a> */}
          </div> 
        </section>


      </main>
    </div>
    )}
    </>
  );
};

export default ProductDetails;
